module.exports = __webpack_public_path__ + "static/img/temp.8679eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backToSchool-2024/temp.png
// module id = Jzzs
// module chunks = 1